import { useMemo } from "react";

import CompaniesModal from "../components/CompaniesModal";
import { useGetAnalytics } from "./hooks/useGetAnalytics";
import HistogramModal from "../components/HistogramModal";
import DistributionHistogramModal from "../components/DistributionHistogramModal";
import CompanyStatCard from "../components/CompanyStatCard";
import DashboardSharedTable from "../components/common/DashboardSharedTable";
import { createDashboardTableSections } from "./config/superDashboardConfig";
import CompanyFilters from "../components/CompanyFilters";
import { dashboardListClasses, dashboardTitleClasses, statCardClasses } from "../../../components/common/dashboardClasses";
import { analyticsStatsGridClasses, chartStatsGridClasses } from "../../../components/common/dashboardGridClasses";
import SuperAdminPageWrapper from "../components/SuperAdminPageWrapper";

const CompanyAnalyticsDashboard = () => {

    const {
        openModal,
        openModalByKey,
        closeModal,
        companyAnalyticsIsLoading,
        statCards,
        dashboardData,
        isTokenInput,
        setIsTokenInput,
        onOpenHistogramModal,
        histogramState,
        closeHistogram,
        selectedDistribution,
        isContentDistributionOpen,
        onOpenContentDistribution,
        closeContentDistribution,
        selectedSettlementDistribution,
        isSettlementHistogramOpen,
        closeSettlementHistogram
    } = useGetAnalytics();

    const dashboardTableSections = useMemo(
        () =>
            createDashboardTableSections({
                isTokenInput,
                setIsTokenInput,
                onOpenHistogramModal,
                onOpenContentDistribution
            }),
        [isTokenInput]
    );

    return (

        <SuperAdminPageWrapper>
            <div className={`container ${dashboardListClasses}`}>
                <div className="flex items-center gap-2 mb-6">
                    <h1 className={dashboardTitleClasses}>Diagnostics</h1>
                    <CompanyFilters />
                </div>
                <div className="mb-6">
                    <div className={`${analyticsStatsGridClasses} mb-6`}>
                        {statCards.map((card, index) => (
                            <CompanyStatCard
                                key={index}
                                icon={card.icon}
                                title={card.title}
                                value={card.value}
                                isLoading={card.isLoading}
                                onClick={() => openModalByKey(card.modal)}
                            />
                        ))}
                    </div>
                    {dashboardTableSections.map((section, sectionIndex) => (
                        <div key={sectionIndex} className={`${chartStatsGridClasses} mb-6`}>
                            {section.map((table, index) => (
                                <DashboardSharedTable
                                    key={index}
                                    title={table.title}
                                    columns={table.columns}
                                    data={dashboardData[table.dataKey] || []}
                                    icon={table.icon}
                                    headerExtra={table.headerExtra}
                                    className={statCardClasses}
                                    onRowClick={table.onRowClick}
                                />
                            ))}
                        </div>
                    ))}
                    <HistogramModal
                        {...histogramState}
                        onClose={closeHistogram}
                    />
                    <CompaniesModal
                        open={!!openModal}
                        configKey={openModal}
                        dashboardData={dashboardData}
                        isLoading={companyAnalyticsIsLoading}
                        onClose={closeModal}
                    />
                    <DistributionHistogramModal
                        openModal={isContentDistributionOpen}
                        closeModal={closeContentDistribution}
                        distribution={selectedDistribution}
                    />
                    <DistributionHistogramModal
                        openModal={isSettlementHistogramOpen}
                        closeModal={closeSettlementHistogram}
                        distribution={selectedSettlementDistribution}
                    />

                </div>
            </div>
        </SuperAdminPageWrapper>


    )
}

export default CompanyAnalyticsDashboard;